module.exports = __webpack_public_path__ + "static/media/dndgif2.f0360162.gif";